import React from "react";
import { IOrderStatus } from "../../interfaces/IOrderStatus";
import { Divider, makeStyles, Text, tokens } from "@fluentui/react-components";
import { ISignForm } from "../../interfaces/ISignForm";
import { ATALogo } from "./ATALogo";
import { Sign } from "../sign-generator/Sign";
import { useTranslation } from "react-i18next";
import { OrderConfirmationMsg } from "../../helper/textTemplates";
type OrderConfirmationProps = {
  orderStatus: IOrderStatus;
  order: ISignForm;
  signRef: React.MutableRefObject<HTMLDivElement>;
  logoRef: React.MutableRefObject<HTMLDivElement>;
};
const useStyles = makeStyles({
  orderConfirmationContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  hiddenPdfLogo: {
    position: "absolute",
    top: "-9999px",
    left: "-9999px",
    width: "fit-content",
    height: "fit-content",
    overflow: "hidden",
    pointerEvents: "none",
    opacity: "0",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginBotton: tokens.spacingVerticalL,
    "> h2": {
      fontSize: tokens.fontSizeBase500,
      fontWeight: tokens.fontWeightBold,
      marginBotton: tokens.spacingVerticalL,
    },
    "> p": {
      fontSize: tokens.fontSizeBase400,
      marginBottom: "0px",
      marginTop: "0px",
    },
    "> div": {
      marginTop: tokens.spacingVerticalM,

      "::before": {
        borderTopWidth: tokens.strokeWidthThick,
      },
      "::after": {
        borderTopWidth: tokens.strokeWidthThick,
      },
    },
  },
  spaceBetween: {
    display: "flex",
    justifyContent: "space-between",
  },
  summary: {
    display: "flex",
    "> div": {
      display: "flex",
      flexDirection: "column",
      "> p": {
        fontSize: tokens.fontSizeBase400,
        marginBottom: "0px",
        marginTop: "0px",
        marginLeft: tokens.spacingVerticalL,
      },
    },
  },
});
export const OrderConfirmation = ({
  orderStatus,
  order,
  signRef,
  logoRef,
}: OrderConfirmationProps) => {
  const styles = useStyles();
  const { t } = useTranslation();
  return (
    <div className={styles.orderConfirmationContainer}>
      {orderStatus?.orderSent ? (
        <>
          <div className={styles.section}>
            <Text as="h2">{t("label.customerInformation")}</Text>
            <Text as="p">{order.customer.companyName}</Text>
            <Text as="p">{order.customer.name}</Text>
            <Text as="p">{order.customer.email}</Text>
            <Text as="p">{order.customer.phone}</Text>
            <Divider appearance="brand" />
          </div>
          <div className={styles.section}>
            <Text as="h2">{t("label.product")}</Text>
            <div className={styles.spaceBetween}>
              <Sign sign={order} signRef={signRef} modalPreview />
              <div className={styles.summary}>
                <div>
                  <Text as="p">{t("label.amount")}</Text>
                  <Text as="p">{t("unit.quantityPrice")}</Text>
                  <Text as="p">{t("label.totalPrice")}</Text>
                </div>
                <div>
                  <Text as="p">{`${`${order.quantity}${t("unit.st")}`}`}</Text>
                  <Text as="p">{`${`${order.quantityPrice}${t(
                    "unit.krVat"
                  )}`}`}</Text>
                  <Text as="p">{`${`${order.totalPrice}${t(
                    "unit.krVat"
                  )}`}`}</Text>
                </div>
              </div>
            </div>
            <div className={styles.hiddenPdfLogo}>
              <ATALogo logoRef={logoRef} />
            </div>
            <Divider appearance="strong" style={{ marginTop: "24px" }} />
            {OrderConfirmationMsg()}
          </div>
        </>
      ) : (
        <Text as="p">{orderStatus?.message}</Text>
      )}
    </div>
  );
};
